@if (!preview) {
   <div class="flex flex-col px-10 py-4 border-2 rounded-md"
      [ngClass]="error ? 'border-red-500' : 'border-gray-900/10'">
      <div class="text-lg font-semibold my-1">
         {{ title }}
      </div>

      <div class="mt-3 border rounded-md bg-gray-50 border-gray-200 p-4">
         <div class="flex flex-col gap-3">
            @for (room of rooms; track room.name) {
            <div
               class="flex items-center justify-between rounded-md border border-gray-200 bg-white px-4 py-3">
               <div class="flex items-center gap-3">

                  <mat-checkbox
                     [checked]="!!room.selected"
                     (change)="toggleRoom(room, $event.checked)"
                     class="text-md text-gray-800">
                     {{ room.name }}
                  </mat-checkbox>
               </div>

               @if (room.selected) {
                  <div class="flex items-center gap-3">
                     <span class="text-sm text-gray-500">Količina</span>
                     <input
                        type="number"
                        min="0"
                        max="10"
                        [(ngModel)]="room.count"
                        (ngModelChange)="clampCount(room)"
                        class="w-[4.25rem] h-9 border rounded-md px-2 text-md focus:outline-none" />
                  </div>
               }
            </div>
            }
         </div>
      </div>
   </div>
}

@if (preview) {
   <div class="flex flex-col px-10 py-4 border-2 rounded-md"
      [ngClass]="error ? 'border-red-500' : 'border-gray-900/10'">
      <div class="text-lg font-semibold my-1">
         {{ title }}
      </div>

      <div class="mt-3 border rounded-md bg-gray-50 border-gray-200 p-4">
         @if (selectedRooms.length > 0) {
            <div class="flex flex-col gap-2">
               @for (room of selectedRooms; track room.name) {
               <div
                  class="flex items-center justify-between rounded-md border border-gray-200 bg-white px-4 py-2">
                  <span class="text-md text-gray-800">{{ room.name }}</span>
                  <span class="text-md font-medium text-gray-700">{{ room.count }}</span>
               </div>
               }
            </div>
         } @else {
            <div class="text-md text-gray-400 italic">-</div>
         }
      </div>
   </div>
}
